import moment, { Moment } from 'moment';
import { useAppContext } from '../Services/AppContext';

const useDateFormatter = () => {
	const { dateFormatMoment } = useAppContext();

	const formatDate = (date: string | Moment) =>
		moment(date).format(dateFormatMoment);

	return { formatDate };
};

export default useDateFormatter;
